import React from 'react';
import { soundService } from '../../services/SoundService';
import { AdPlaceholder } from '../shared/AdPlaceholder';
import './ChallengesScreen.css';

interface ChallengesScreenProps {
    onStartChallenge: (type: 'great_escape' | 'youth_academy' | 'debt_crisis', gameType: 'mens' | 'womens') => void;
    onBack: () => void;
}

const challenges = [
    {
        type: 'great_escape',
        title: 'The Great Escape',
        description: 'Take over a team mid-season, languishing deep in the relegation zone. Can you defy the odds and keep them in the league?',
        icon: '🏃‍♂️',
        gameType: 'mens'
    },
    {
        type: 'youth_academy',
        title: 'Youth Academy',
        description: 'Your club is under a transfer ban! You must rely on your youth academy to build a dynasty. Can you win the top league with homegrown talent?',
        icon: '🌱',
        gameType: 'mens'
    },
    {
        type: 'debt_crisis',
        title: 'Debt Crisis',
        description: 'This club is on the brink of financial collapse, starting with a £20,000,000 debt. Can you balance the books and lead them to glory?',
        icon: '💸',
        gameType: 'mens'
    },
];

export const ChallengesScreen: React.FC<ChallengesScreenProps> = ({ onStartChallenge, onBack }) => {

    const handleStart = (type: 'great_escape' | 'youth_academy' | 'debt_crisis', gameType: 'mens' | 'womens') => {
        soundService.playSuccess();
        onStartChallenge(type, gameType);
    };

    return (
        <>
            <AdPlaceholder />
            <div className="start-screen-container">
                <div className="start-screen-pitch-bg" />
                <div className="challenges-container">
                <button onClick={onBack} className="back-button">← Back to Main Menu</button>
                <h1>Challenge Modes</h1>
                <p>Test your managerial skills in these unique scenarios!</p>
                <div className="challenges-grid">
                    {challenges.map(challenge => (
                        <div key={challenge.type} className="challenge-card">
                            <div className="challenge-icon">{challenge.icon}</div>
                            <h3>{challenge.title}</h3>
                            <p>{challenge.description}</p>
                            <button 
                                className="button primary" 
                                onClick={() => handleStart(challenge.type as any, challenge.gameType as any)}
                            >
                                Start Challenge
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </>
    );
};
